import {Component, OnInit} from '@angular/core';
import * as KeycloakAngular from "keycloak-angular";
import {ActivatedRoute, Router} from "@angular/router";
import {Realm} from "@app/keycloak/realm";
import {GrowlService, UserService} from "@app/core";
import {KeycloakActionType} from "@app/keycloak/keycloak-action-type";
import {KeycloakSupportService} from "@app/core/keycloak/keycloak-support.service";
import {NgxSpinnerService} from "ngx-spinner";
import {RouteLink} from "@app/shared";

@Component({
  selector: 'app-check-auth',
  templateUrl: './check-auth.component.html',
  styleUrls: ['./check-auth.component.css']
})
export class CheckAuthComponent implements OnInit {

  isLoading = false;
  isLoggedIn = false;
  spinnerName = "spinner";

  constructor(private router: Router, private route: ActivatedRoute,
              private user: UserService,
              private keycloakAngular: KeycloakAngular.KeycloakService,
              private keycloakSupport: KeycloakSupportService,
              private spinner: NgxSpinnerService,
              private growl: GrowlService) {

    let url = new URL(window.location.href);
    this.isLoading = url.searchParams.get("action") == KeycloakActionType.Return;

    if (this.isLoading) {
      void this.spinner.show(this.spinnerName);
    }
  }

  async ngOnInit() {
    this.isLoggedIn = await this.keycloakAngular.isLoggedIn();
  }

  handleRealmSelection(realm: Realm): void {
    void this.router.navigate([RouteLink.Gateway],
      {
        queryParams: {
          action: KeycloakActionType.Login,
          realm: realm.name,
          clientId: realm.clientId
        }
      }).then();
  }
}
